var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "current",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Formatting / underline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.25 15.5V17H3.75V15.5H14.25ZM12 10.4113C11.9753 10.9062 11.8284 11.3874 11.5723 11.8117C11.3162 12.2361 10.9591 12.5904 10.5326 12.8429C10.1062 13.0955 9.62388 13.2385 9.12871 13.2592C8.63353 13.2798 8.14096 13.1775 7.695 12.9613C7.18098 12.7389 6.74505 12.3681 6.44308 11.8964C6.1411 11.4247 5.98682 10.8737 6 10.3138V4.25375H4.5V10.4113C4.52537 11.1173 4.71664 11.8075 5.05831 12.4259C5.39999 13.0443 5.88247 13.5735 6.4667 13.9708C7.05094 14.3681 7.7205 14.6222 8.42121 14.7126C9.12191 14.8031 9.83406 14.7272 10.5 14.4913C11.3858 14.196 12.1544 13.6259 12.6939 12.8638C13.2335 12.1017 13.5158 11.1874 13.5 10.2537V4.25375H12V10.4113ZM12 4.25H13.5H12ZM6 4.25H4.5H6Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.996be60b2671d8ef2b8bb2c52ed489df.svg";
export { ForwardRef as ReactComponent };